<template>
  <!--新增管家app菜单-->
  <x-addApplication></x-addApplication>
</template>

<script>
export default {
  name: 'addStewardApp'
};
</script>

<style scoped>

</style>
